module.exports = __webpack_public_path__ + "static/media/Range of Gift Packs.d54a6c14.jpg";